'use strict';

var AuthError = require('./AuthError.js');

class AuthWindowClosedError extends AuthError.AuthError {
    constructor(params) {
        const { message = 'Child window for authentication was closed', phone } = params || {};
        super({ message, phone });
    }
}

exports.AuthWindowClosedError = AuthWindowClosedError;
//# sourceMappingURL=AuthWindowClosedError.js.map
